<template>
  <div>
    <div class="section-block">
      <font-awesome-icon icon="calendar-check" class="fa-fw" />Uitslagen
    </div>
    <table class="table table-sm">
      <tbody>
        <tr v-for="item in passedGames" :key="item.index">
          <td>
            <small>{{ item.date | formatDayName }} {{ item.date | formatDate }}</small>
          </td>
          <td class="text-left">
            <span
              v-bind:class="{ 'font-weight-bold': item.homeScore > item.outScore }"
            >{{ item.homeTeam }} ({{item.homeRank}})</span>
            <br />
            <span
              v-bind:class="{ 'font-weight-bold': item.outScore > item.homeScore }"
            >{{item.outTeam}} ({{item.outRank}})</span>
          </td>
          <td class="text-right">
            <span
              v-bind:class="{ 'font-weight-bold': item.homeScore > item.outScore }"
            >{{ item.homeScore }}</span>
            <br />
            <span
              v-bind:class="{ 'font-weight-bold': item.outScore > item.homeScore }"
            >{{item.outScore}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Results",
  props: {
    data: Array
  },
  data: function() {
    return {
      passedGames: Array,
      futureGames: Array
    };
  },
  created: function() {
    this.passedGames = this.data.filter(x => x.isPassed).sort(function(a,b){
  // Turn your strings into dates, and then subtract them
  // to get a value that is either negative, positive, or zero.
  return new Date(b.date) - new Date(a.date);
});
    this.futureGames = this.data.filter(x => !x.isPassed);
  }
};
</script>

<style scoped>
</style>
